{
  "name": "@ns/public-ledger-auto-payments-raise-target",
  "version": "1.1.0",
  "description": "An action waits because it needs more credits than automatic payments top the company's operating account up to (#25 phase 6, refusal reason ABOVE_OPERATING_TARGET). Shows what it needs (NEEDED_CREDITS), the operating target now (OPERATING_TARGET_CREDITS) and the smallest target that covers it (SUGGESTED_TARGET_CREDITS); liquidity-check keeps the figures up to date. Claimable by the company's public ledger signatories; one open per company. raise (card-action raise) starts Change automatic payments amounts as the workflow's child, pre-filled with the suggested target; the card closes when the change applies and opens again as a new card when it doesn't. cancel (the holder, through card-action cancel) ends the card: each person waiting for the raise is told it won't be raised, they keep waiting, and liquidity-check raises no new card for those refusals (DECLINED on the workflow). It never closes by itself when nothing waits for it any more: only a raise that applies or a cancel ends it.",
  "inputs": {},
  "outcomes": {
    "raise": {
      "serverOnly": true
    },
    "cancel": {
      "serverOnly": true
    },
    "stopped": {
      "serverOnly": true
    }
  }
}
